<div class="bg-white p-5">
  <section>
    <h2 class="text-xl font-bold mb-4 text-dc-navy">
      {{ "PLAT.TITLE" | translate }}
    </h2>

    <ul class="list-disc ltr:pl-6 rtl:pr-6 space-y-3 text-dc-navy!">
      @for (index of [0, 1, 2, 3, 4, 5, 6, 7]; track index) {
        <li>
          <h4 class="text-base font-semibold text-dc-navy mb-1">
            {{ ("PLAT.BENEFITS." + index + ".HEAD") | translate }}
          </h4>

          <p class="mb-1!">
            {{ ("PLAT.BENEFITS." + index + ".TEXT") | translate }}
          </p>
        </li>
      }
    </ul>
  </section>
</div>
